import { render, staticRenderFns } from "./project-monitoring.vue?vue&type=template&id=06e27762&scoped=true&"
import script from "./project-monitoring.vue?vue&type=script&lang=ts&"
export * from "./project-monitoring.vue?vue&type=script&lang=ts&"
import style0 from "./project-monitoring.vue?vue&type=style&index=0&lang=css&"
import style1 from "./project-monitoring.vue?vue&type=style&index=1&id=06e27762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e27762",
  null
  
)

export default component.exports